import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import Chip from "@mui/material/Chip";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import InfoIcon from "@mui/icons-material/Info";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#007FFF",
    color: theme.palette.common.white,
    fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  "& > :not(style) ~ :not(style)": {
    marginTop: theme.spacing(5),
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  userData: any;
  title: any;
}

function FileDetailSwipeableDrawer({ open, onClose, title, userData }: Props) {
  // console.log("data", userData?.approvalForReg);
  // console.log("check", )
  const handleClose = () => {
    onClose();
    // userData("");
    // setRegistrationData("");
  };


  return (
    <div>
      <SwipeableDrawer
        anchor="right"
        open={open}
        onClose={() => {}}
        onOpen={() => {}}
        slotProps={{
          backdrop: {
            style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
          },
        }}
        PaperProps={{
          style: {
            boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.2)",
            backgroundColor: "white",
          },
        }}
        style={{
          zIndex: 1300,
        }}
      >
        <Box sx={{ backgroundColor: "whitesmoke" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              left: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            {" "}
            <CloseIcon />
          </IconButton>
          <p
            style={{
              paddingTop: "2vh",
              paddingBottom: "2vh",
              paddingLeft: "10vh",
              //   textAlign: "center",
              fontSize: "20px",
            }}
          >
            {title}
          </p>
          
          <Divider />
        </Box>

       

        <Box sx={{ p: 2 }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: "60vh", backgroundColor: "#fff", boxShadow: 1 }}
              aria-label="customized table"
            >
              <TableBody>
                {userData?.map((row: any) => (
                  <React.Fragment key={row.fileID}>
                    <StyledTableRow>
                       <StyledTableCell
                        colSpan={2}
                        align="left"
                        style={{
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>File Name. :</span>{" "}
                        {row.fileName}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          File Number :{" "}
                        </span>
                        {row.fileNo}{" "}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          RFID :
                        </span>{" "}
                        {row.rfid}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          Synopsis :{" "}
                        </span>
                        {row.synopsis}{" "}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          Chak No :
                        </span>{" "}
                        {row.chackNo}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          Total Page :
                        </span>{" "}
                        {row.totalPages}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {" "}
                        <span style={{ fontWeight: 600 }}>
                          From Page :
                        </span>{" "}
                        {row.fromPage}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                    <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>To Page :</span>{" "}
                        {row.toPage}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>
                        Status:
                        </span>{" "}
                        {(row.status === "2"?<>Issue</>:<>N/A</>)}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                    <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>File Type :</span>{" "}
                        {row.fileTypeName}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>
                        File Group:
                        </span>{" "}
                        {row.fileGroupName}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                    <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>File Category :</span>{" "}
                        {row.fileCategoryName}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <span style={{ fontWeight: 600 }}>
                        File Class:
                        </span>{" "}
                        {row.className}
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="left">
                          <span style={{ fontWeight: 600 }}>Jurisdiction :</span>{" "}
                          {row.nodeName}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <span style={{ fontWeight: 600 }}>
                          File Subject:
                          </span>{" "}
                          {row.fileSubjectName}
                        </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="left">
                          <span style={{ fontWeight: 600 }}>Sender :</span>{" "}
                          {row.senderID}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <span style={{ fontWeight: 600 }}>
                          Receiver:
                          </span>{" "}
                          {row.receiverID}
                        </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                    <StyledTableCell
                        colSpan={2}
                        align="left"
                        style={{
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>Current Location :</span>{" "}
                        {row.currentLocation}
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                    <StyledTableCell
                        colSpan={2}
                        align="left"
                        style={{
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>Remark:</span>{" "}
                        {row.remark}
                      </StyledTableCell>
                    </StyledTableRow>


                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

<br/>
          {userData?.length > 0 ? (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: "60vh", backgroundColor: "#f4f4f5", boxShadow: 1 }}
                aria-label="customized table"
              >
               
                <TableBody>
                  {userData?.map((row: any) => (
                    <React.Fragment key={row.fileID}>
                      <StyledTableRow>
                       
                        <StyledTableCell align="center">
                          {" "}

          <embed
            src={`${row.fileDoc}`}
            //alt={`${row.fileName}`}
            style={{ width:"95%", height: "35vh", alignItems:"center" }}
          />

                        </StyledTableCell>
                      </StyledTableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            "No File Found"
          )}

        </Box>
      </SwipeableDrawer>
    </div>
  );
}

export default FileDetailSwipeableDrawer;
